import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle_arrow_left",
  "use": "circle_arrow_left-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle_arrow_left\">\n<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#2D2D2D\" />\n<path d=\"M7.75488 8.8891L5.86763 7.00185L7.75488 5.11459\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol